import React from 'react'
import { navigate, PageProps } from 'gatsby'
import {
  Error,
  ErrorAlert,
  SEO,
  showMessage,
  Skeleton,
} from 'components/common'
import { routes } from 'config'
import {
  DiscountCreateInput,
  useDiscountDeleteMutation,
  useDiscountQuery,
  useDiscountUpdateMutation,
} from 'lib/graphql/storeadmin'
import { ShowDiscount } from 'components/discounts/form'
import { useState } from 'react'
import { discountErrorHandling } from 'lib/hooks'
export const Head = () => <SEO title="ディスカウントの編集" />

const IdEditPage = ({ params }: PageProps): JSX.Element => {
  const { data, loading, error } = useDiscountQuery({
    variables: { id: params.id },
  })

  const [updateDiscount] = useDiscountUpdateMutation()
  const [deleteDiscount] = useDiscountDeleteMutation()
  const [showDiscountErrorAlert, setShowDiscountErrorAlert] = useState(false)
  const [discountErrorDescription, setDiscountErrorDescription] = useState([])

  if (loading) return <Skeleton />
  if (error) return Error.render(error)

  const onFinish = async (values: DiscountCreateInput) => {
    try {
      const customerSelectionValue = values.customerSelection.map(
        (customer) => customer['value'] ?? customer
      )

      const inputValue = {
        ...values,
        customerSelection: customerSelectionValue,
        product: values.product?.['value'] ?? values.product,
        canOverlap: values.canOverlap['value'] ?? values.canOverlap,
        discountPercent:
          values.discountPercent['value'] ?? values.discountPercent,
        status: values.status,
      }

      const { data } = await updateDiscount({
        variables: { id: params.id, input: inputValue },
      })

      const { discountUpdate } = data
      const userErrors = discountUpdate?.discountUserErrors || []

      if (userErrors.length > 0) {
        const errorMessages = discountErrorHandling(userErrors)
        setDiscountErrorDescription(errorMessages)
        setShowDiscountErrorAlert(true)
        showMessage('error', 'エラーが発生しました。')
      } else {
        setShowDiscountErrorAlert(false)
        showMessage('success', 'ディスカウントを更新しました。')
      }
    } catch (e) {
      setShowDiscountErrorAlert(true)
      setDiscountErrorDescription([e.message])
      showMessage('error', 'サーバーとの通信時にエラーが発生しました。')
    }
  }

  const onDelete = async () => {
    try {
      const { data: deleteData } = await deleteDiscount({
        variables: { id: data?.discount?.id },
      })

      const { discountDelete } = deleteData
      const userErrors = discountDelete?.discountUserErrors || []

      if (userErrors.length > 0) {
        const errorMessages = discountErrorHandling(userErrors)
        setDiscountErrorDescription(errorMessages)
        setShowDiscountErrorAlert(true)
        showMessage('error', 'エラーが発生しました。')
      } else {
        setShowDiscountErrorAlert(false)
        showMessage('success', 'ディスカウントを削除しました。')
        navigate(routes.discounts)
      }
    } catch (e) {
      setShowDiscountErrorAlert(true)
      setDiscountErrorDescription([e.message])
      showMessage('error', 'サーバーとの通信時にエラーが発生しました。')
    }
  }

  const onCloseAlert = () => {
    setShowDiscountErrorAlert(false)
  }
  return (
    <>
      {showDiscountErrorAlert && (
        <ErrorAlert
          onCloseAlert={onCloseAlert}
          alertDescription={discountErrorDescription}
        />
      )}
      <ShowDiscount
        onSubmit={onFinish}
        onDelete={onDelete}
        initialData={data.discount}
        created={false}
        loading={loading}
      />
    </>
  )
}

export default IdEditPage
